import ImageUpload from './components/ImageUpload';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'imageUpload',
  pluginComponent: ImageUpload,
});
